import { FILE_CONSTANTS } from "@home-health-notify/domain";

export const config = {
  baseUrl: process.env.REACT_APP_baseUrl || "",
  region: process.env.REACT_APP_region || "",
  userPoolId: process.env.REACT_APP_userPoolId || "",
  userPoolWebClientId: process.env.REACT_APP_userPoolWebClientId || "",
  cognitoOAuthDomain: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN || "",
  cognitoRedirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || "",
  cognitoRedirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT || "",
  platformType: process.env.REACT_APP_platformType || "",
  applicationVersion: process.env.REACT_APP_applicationVersion || "",
  apiVersion: process.env.REACT_APP_apiVersion || "",
  acl: process.env.REACT_APP_acl || "",
  env: process.env.REACT_APP_env || "local",
  adminPanelUrl: process.env.REACT_APP_adminPanelUrl || "",
  googleMapId: "1bf0ec063c0168f1",
  googleMapKey: process.env.REACT_APP_GOOGLE_MAP_KEY || "",
  fileSizeLimitBytes:
    (process.env.REACT_APP_S3_FILE_SIZE_LIMIT_BYTES &&
      parseInt(process.env.REACT_APP_S3_FILE_SIZE_LIMIT_BYTES)) ||
    FILE_CONSTANTS.FILE_SIZE_LIMIT_BYTES,
  cookieDomain: process.env.REACT_APP_cookieDomain || "",
  emrReportingHost: process.env.REACT_APP_emrReportingHost || "",
  emrEnabledOrgs: (() => {
    try {
      const orgs = JSON.parse(
        process.env.REACT_APP_emrEnabledOrgs || "[]",
      ) as string[];
      return orgs.filter(
        (orgId): orgId is string => typeof orgId === "string" && !!orgId,
      );
    } catch {
      return [];
    }
  })(),
  slowMessageThresholdMs:
    process.env.REACT_APP_SLOW_MESSAGE_THRESHOLD_MS !== undefined
      ? parseInt(process.env.REACT_APP_SLOW_MESSAGE_THRESHOLD_MS) || 0
      : 6000,
};
export default config;
